import {
  Avatar,
  Badge,
  Button,
  Flex,
  IconButton,
  Td,
  Text,
  Tr,
  useColorModeValue,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import React from "react";
import UserDetailDialog from "./UserDetailDialog";
import { DeleteIcon, EditIcon, UnlockIcon } from "@chakra-ui/icons";
import UserResetPasswordDialog from "./UserResetPasswordDialog";
import { ROOT_API } from "utils/constant";
import { API_ROUTES } from "utils/constant";
import { axiosPost } from "utils/api";

function UserRow(props) {
  const {
    userDetail,
    logo,
    name,
    email,
    phone,
    role,
    status,
    date,
    isLast,
    handelUpdateUser,
    refetch,
  } = props;
  // BE handler `deleteUser` destructure `id` từ req.body và dùng
  // findByIdAndDelete → phải gửi field tên `id` = userDetail._id.
  const id = userDetail?._id;
  const toast = useToast();
  const textColor = useColorModeValue("gray.500", "white");
  const titleColor = useColorModeValue("gray.700", "white");
  const bgStatus = useColorModeValue("gray.400", "navy.900");
  const borderColor = useColorModeValue("gray.200", "gray.600");
  const { isOpen, onOpen, onClose } = useDisclosure();

  function handleRowClickResetPassword() {
    onOpen();
  }

  function handleRowClick() {
    console.log("==========> ROY <============", userDetail);
    handelUpdateUser(userDetail);
  }

  const {
    isOpen: isDetailOpen,
    onOpen: onDetailOpen,
    onClose: onDetailClose,
  } = useDisclosure();

  async function handleDeleteClick() {
    if (window.confirm("Are you sure to delete this user")) {
      const memberData = {
        id,
      };
      try {
        const data = await axiosPost(
          ROOT_API + API_ROUTES.USER_DELETE,
          memberData
        );
        if (data?.data?.code == 0) {
          toast({
            title: "Delete user Successfully",
            status: "success",
            duration: 9000,
            isClosable: true,
          });
          refetch();
        }
      } catch (error) {
        toast({
          title:
            error?.response?.data?.errors?.errors[0]?.msg ||
            error?.response?.data?.msg ||
            "Delete user Fail",
          status: "error",
          duration: 9000,
          isClosable: true,
        });
      }
    }
  }

  return (
    <Tr>
      <Td
        minWidth={{ sm: "250px" }}
        pl="0px"
        borderColor={borderColor}
        borderBottom={isLast ? "none" : null}
      >
        <UserDetailDialog
          isOpen={isDetailOpen}
          onOpen={onDetailOpen}
          onClose={onDetailClose}
          // tool={name}
          data={props}
        />
        <UserResetPasswordDialog
          isOpen={isOpen}
          onOpen={onOpen}
          onClose={onClose}
          fetchData={refetch}
          id={id}
        />
        <Flex align="center" py=".8rem" minWidth="100%" flexWrap="nowrap">
          <Avatar src={logo} w="50px" borderRadius="12px" me="18px" />
          <Flex direction="column">
            <Text
              fontSize="md"
              color={titleColor}
              fontWeight="bold"
              minWidth="100%"
            >
              {name}
            </Text>
            <Text fontSize="sm" color="gray.400" fontWeight="normal">
              {email}
            </Text>
          </Flex>
        </Flex>
      </Td>

      <Td borderColor={borderColor} borderBottom={isLast ? "none" : null}>
        <Flex direction="column">
          <Text fontSize="md" color={textColor} fontWeight="bold">
            {phone}
          </Text>
        </Flex>
      </Td>

      <Td borderColor={borderColor} borderBottom={isLast ? "none" : null}>
        <Flex direction="column">
          <Text fontSize="md" color={textColor} fontWeight="bold">
            {role}
          </Text>
        </Flex>
      </Td>

      <Td borderColor={borderColor} borderBottom={isLast ? "none" : null}>
        <Flex>
          <IconButton
            p={2}
            color="blue.400"
            bg="transparent"
            onClick={() => {
              handleRowClick();
            }}
          >
            <EditIcon />
          </IconButton>
          <IconButton
            p={2}
            bg="transparent"
            onClick={() => {
              handleRowClickResetPassword();
            }}
          >
            <UnlockIcon />
          </IconButton>
          <IconButton
            p={2}
            color="red.400"
            bg="transparent"
            onClick={() => {
              handleDeleteClick();
            }}
          >
            <DeleteIcon />
          </IconButton>
        </Flex>
      </Td>
    </Tr>
  );
}

export default UserRow;
